export enum EAuthorizationType {
  None = 0,
  Basic = 1,
  JWT = 2
}

export enum ETokenSource {
  LocalStorage = 1,
  DataBase = 2
}

export enum ApihttpMethods
{
    POST = 1,
    GET = 2,
    PUT = 3,
    DELETE = 4
}

export enum ApiTypes
{
    WebApi = 1,
    WCF = 2,
    ASMX = 3,
    Other = 4
}

export enum EStatus
{
    Unpublished = 1,
    Published = 2,
    Deleted = 3,
    Inactive = 4,
    Active = 5,
    All = 6
}

export enum EApiReponseType
{
    Array = 1,
    Object = 2,
    String = 3,
    Number = 4
}

export enum EImportance
{
    High = 1,
    Medium = 2,
    Low = 3
}

export enum ERepeatType
{
    OneTime = 3,
    Periodic = 4,
    Weekly = 5,
    Monthly = 6,
    InMonth = 7,
    Annual = 8
}

export enum EventPlace
{
    Inhouse = 1,
    External = 2
}

export enum EPeriodType
{
  Days = 1,
  Weeks = 2,
  Months = 3
}
